import { render } from "./Shape.vue?vue&type=template&id=39827806"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"

import "./Shape.vue?vue&type=style&index=0&id=39827806&lang=css"

import exportComponent from "/Users/paul/Documents/websites/shape/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__